<template>
  <div class="register-bg">
    <div class="register-container">
      <div class="system-logo">
        <div class="logo-icon">
          <i class="el-icon-cloudy"></i>
        </div>
        <h1 class="system-title">4KHD 网盘资源管理系统</h1>
      </div>
      <el-card class="register-card tech-card">
        <div class="register-header">
          <h2 class="register-title tech-title">用户注册</h2>
          <el-button type="text" class="login-link" @click="$router.push('/login')">返回登录</el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="registerForm" label-width="80px" @keyup.enter.native="onRegister" class="tech-form">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form.username" autocomplete="username" prefix-icon="el-icon-user" class="tech-input" />
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="form.password" type="password" autocomplete="new-password" prefix-icon="el-icon-lock" class="tech-input" />
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="form.confirmPassword" type="password" autocomplete="new-password" prefix-icon="el-icon-lock" class="tech-input" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="onRegister" class="register-btn tech-btn">注册</el-button>
          </el-form-item>
          <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" style="margin-bottom:0" />
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    // 自定义确认密码校验
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      },
      loading: false,
      error: ''
    }
  },
  methods: {
    onRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        this.error = '';
        try {
          const { username, password } = this.form;
          const res = await this.$axios.post('/user/register', { username, password });
          if (res && res.code === 200) {
            this.$message.success('注册成功，请登录');
            this.$router.push('/login');
          } else {
            this.error = res.message || '注册失败';
          }
        } catch (e) {
          this.error = e.response?.data?.message || '网络错误';
        } finally {
          this.loading = false;
        }
      });
    }
  }
}
</script>

<style scoped>
.register-bg {
  min-height: 100vh;
  background: #22313a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.register-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.system-logo {
  text-align: center;
  margin-bottom: 40px;
}

.logo-icon {
  font-size: 3rem;
  color: #409EFF;
  margin-bottom: 16px;
}

.system-title {
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin: 0 0 8px 0;
  font-family: 'Arial', 'Microsoft YaHei', sans-serif;
}

.register-card {
  width: 360px;
  padding: 32px 24px 20px 24px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
}

.register-card:hover {
  box-shadow: 0 4px 18px rgba(0,0,0,0.10);
  transform: none;
}

.register-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.register-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #222;
  letter-spacing: 1px;
  margin: 0;
}

.tech-title {
  background: none !important;
  -webkit-background-clip: initial !important;
  -webkit-text-fill-color: initial !important;
  background-clip: initial !important;
  color: #222 !important;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 0;
}

.login-link {
  color: #409EFF;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  transition: color 0.2s;
}

.login-link:hover {
  color: #66b1ff;
  text-shadow: none;
}

.tech-form .el-form-item__label {
  color: #333;
  font-weight: 500;
}

.register-btn {
  width: 100%;
  font-size: 16px;
  letter-spacing: 1px;
  border-radius: 6px;
  background: #409EFF;
  border: none;
  height: 42px;
  font-weight: 600;
  color: #fff;
  transition: background 0.2s;
}

.register-btn:hover {
  background: #66b1ff;
  box-shadow: none;
  transform: none;
}

@media (max-width: 768px) {
  .system-title {
    font-size: 1.3rem;
  }
  .register-card {
    width: 95%;
    max-width: 340px;
    padding: 20px 8px 12px 8px;
  }
  .logo-icon {
    font-size: 2.2rem;
  }
}
</style> 